// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1280px) and (max-width: 1535px) {
  :root {
    --nav-bar-height: 40px;
  }
}

@media (min-width: 1280px) {
  #datetime-input {
    position: absolute;
    bottom: 10px;
    display: none;
  }

  #datetime-input-tb {
    color: white;
    font-family: 'Open Sans', sans-serif;
    padding: 10px 10px 11px 10px;
    /* Moves it below screen */
    height: 0px !important;
    margin: 0 0 55px 0 !important;
  }

  #datetime-input-tb:focus,
  input:focus {
    outline: none;
  }

  #datetime-title {
    position: absolute;
    left: 20px;
    bottom: 20px;
    width: 220px;
    height: 30px;
    background: transparent;
    overflow: hidden;
    text-align: center;
    font-weight: bold;
    font-size: 12px;
  }

  #sensor-selected-container {
    padding: 0px 10px 0px 10px;
    border-left: 5px solid var(--color-dark-border);
  }

  #share-icon {
    display: none;
  }

  #search-holder {
    right: 0px;
    top: 0px;
    display: inline-flex;
  }

  #search {
    height: 28px;
    margin: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  #ui-datepicker-div {
    position: relative !important;
    border-radius: 0px;
  }

  #time-machine-menu {
    padding-left: 35px;
    color: white;
    background: var(--color-dark-background);
    width: 300px;
    top: 25px;
    right: 0px;
    z-index: 100;
    position: absolute;
    overflow: auto;
    border-width: 0px 0px 5px 5px;
    border-style: solid;
    border-color: var(--color-dark-border);
  }

  #obfit-menu {
    width: 500px;
  }

  #layers-hover-menu {
    padding-left: 5px;
    color: white;
    background: var(--color-dark-background);
    width: 300px;
    top: var(--top-menu-height);
    right: 0px;
    z-index: 100;
    position: absolute;
    overflow: auto;
    border-width: 0px 0px 5px 5px;
    border-style: solid;
    border-color: var(--color-dark-border);
  }

  .side-menu {
    position: absolute;
    inset: 0;
    background: var(--color-dark-background);
    color: white;
    overflow-x: hidden;
    overflow-y: auto;
    z-index: 10;
  }

  #about-menu {
    width: 375px;
  }

  #multi-sensor-look-angles-menu {
    width: 450px;
  }

  #findByLooks .row {
    margin: 0px;
  }

  #findByLooks .row div input {
    height: 2.5rem;
    margin: 0px;
  }

  #dops-menu {
    width: 400px;
  }

  #menu-satellite-collision,
  #FindSatPlugin-bottom-icon {
    display: inline;
  }

  #footer-toggle-wrapper {
    width: 50%;
    left: 25%;
    z-index: 1;
    position: relative;
  }

  .footer-slide-down {
    bottom: calc(-1 * var(--bottom-menu-height) + 5px) !important;
    height: var(--bottom-menu-height) !important;
    top: auto !important;
  }

  .footer-slide-trans {
    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .footer-slide-up {
    bottom: 0px !important;
    top: auto !important;
  }

  footer {
    margin-top: -100px;
    position: absolute;
    bottom: 0px;
    height: 120px;
    width: 100%;
  }

  #social {
    display: block;
    margin-top: -75px;
    margin-right: 90px;
  }

  #menu-space-stations,
  #menu-launches {
    display: inline;
  }

  #fastCompSettings {
    display: block;
  }

  #mobile-warning {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/responsive-xl.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,oCAAoC;IACpC,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;IACtB,6BAA6B;EAC/B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,+CAA+C;EACjD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,QAAQ;IACR,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,wCAAwC;IACxC,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,6DAA6D;IAC7D,4CAA4C;IAC5C,oBAAoB;EACtB;;EAEA;IACE,2GAA2G;EAC7G;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["@media (min-width: 1280px) and (max-width: 1535px) {\n  :root {\n    --nav-bar-height: 40px;\n  }\n}\n\n@media (min-width: 1280px) {\n  #datetime-input {\n    position: absolute;\n    bottom: 10px;\n    display: none;\n  }\n\n  #datetime-input-tb {\n    color: white;\n    font-family: 'Open Sans', sans-serif;\n    padding: 10px 10px 11px 10px;\n    /* Moves it below screen */\n    height: 0px !important;\n    margin: 0 0 55px 0 !important;\n  }\n\n  #datetime-input-tb:focus,\n  input:focus {\n    outline: none;\n  }\n\n  #datetime-title {\n    position: absolute;\n    left: 20px;\n    bottom: 20px;\n    width: 220px;\n    height: 30px;\n    background: transparent;\n    overflow: hidden;\n    text-align: center;\n    font-weight: bold;\n    font-size: 12px;\n  }\n\n  #sensor-selected-container {\n    padding: 0px 10px 0px 10px;\n    border-left: 5px solid var(--color-dark-border);\n  }\n\n  #share-icon {\n    display: none;\n  }\n\n  #search-holder {\n    right: 0px;\n    top: 0px;\n    display: inline-flex;\n  }\n\n  #search {\n    height: 28px;\n    margin: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  #ui-datepicker-div {\n    position: relative !important;\n    border-radius: 0px;\n  }\n\n  #time-machine-menu {\n    padding-left: 35px;\n    color: white;\n    background: var(--color-dark-background);\n    width: 300px;\n    top: 25px;\n    right: 0px;\n    z-index: 100;\n    position: absolute;\n    overflow: auto;\n    border-width: 0px 0px 5px 5px;\n    border-style: solid;\n    border-color: var(--color-dark-border);\n  }\n\n  #obfit-menu {\n    width: 500px;\n  }\n\n  #layers-hover-menu {\n    padding-left: 5px;\n    color: white;\n    background: var(--color-dark-background);\n    width: 300px;\n    top: var(--top-menu-height);\n    right: 0px;\n    z-index: 100;\n    position: absolute;\n    overflow: auto;\n    border-width: 0px 0px 5px 5px;\n    border-style: solid;\n    border-color: var(--color-dark-border);\n  }\n\n  .side-menu {\n    position: absolute;\n    inset: 0;\n    background: var(--color-dark-background);\n    color: white;\n    overflow-x: hidden;\n    overflow-y: auto;\n    z-index: 10;\n  }\n\n  #about-menu {\n    width: 375px;\n  }\n\n  #multi-sensor-look-angles-menu {\n    width: 450px;\n  }\n\n  #findByLooks .row {\n    margin: 0px;\n  }\n\n  #findByLooks .row div input {\n    height: 2.5rem;\n    margin: 0px;\n  }\n\n  #dops-menu {\n    width: 400px;\n  }\n\n  #menu-satellite-collision,\n  #FindSatPlugin-bottom-icon {\n    display: inline;\n  }\n\n  #footer-toggle-wrapper {\n    width: 50%;\n    left: 25%;\n    z-index: 1;\n    position: relative;\n  }\n\n  .footer-slide-down {\n    bottom: calc(-1 * var(--bottom-menu-height) + 5px) !important;\n    height: var(--bottom-menu-height) !important;\n    top: auto !important;\n  }\n\n  .footer-slide-trans {\n    transition: transform var(--kt-duration-slow, 300ms) var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .footer-slide-up {\n    bottom: 0px !important;\n    top: auto !important;\n  }\n\n  footer {\n    margin-top: -100px;\n    position: absolute;\n    bottom: 0px;\n    height: 120px;\n    width: 100%;\n  }\n\n  #social {\n    display: block;\n    margin-top: -75px;\n    margin-right: 90px;\n  }\n\n  #menu-space-stations,\n  #menu-launches {\n    display: inline;\n  }\n\n  #fastCompSettings {\n    display: block;\n  }\n\n  #mobile-warning {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
